/*
import {
  _ht,
  _hm,
  gs,
  f,
} from 'lib';
*/
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as gs from "./_csGbl";
import * as _cv_10___Mz from "./_cv_10___Mz";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_40___Mz from "./_cv_40___Mz";
import * as _ht from './_ht';
import * as _hm from './_hf';

import * as ihd from './ihd';

export const itlI17z = () => ({
  i17rz: {},
}) as _ht.dz;

export const crtI17z = async () => {
  const _gUserz = gs.useUserz();
  const _i17z = itlI17z();
  _hm.udtDz(_i17z.i17rz, {
    ... ihd.i('i17r'),
    i17r_31r1f: _gUserz.crt._31rz._fst,
  });
  return _i17z;
};

export const loadI17rLsAsync = async (pz: {
  _31r_fst: _ht.n,
  i18r_fst?: _ht.n,
}) => {
  _hm.logOst('icvI17___Mz.loadI17rLsAsync -> ihdI17.grtPzForLoadI17rPs');
  let _cdn = cmFTH.vdd();
  if (pz._31r_fst && pz._31r_fst != 0) _cdn += ` AND i17r_31r1f=${pz._31r_fst}`;
  if (_hm.f(pz?.i18r_fst)) {
    _cdn += ` AND _fst NOT IN (
      SELECT
        i152i17r1f
      FROM
        i152s
      WHERE
        ${cmFTH.vdd(false)}
        AND i152i15r1k = (
          SELECT
            _key
          FROM
            i15rs
          WHERE
            ${cmFTH.vdd()}
            AND _fst = (
              SELECT
                i18ri15r1f
              FROM
                i18rs
              WHERE
                ${cmFTH.vdd()}
                AND _fst = ${pz?.i18r_fst}
            )
        )
    )`;
  }
  const _ls = await cmFTH.loadLsAsync({
    tgt: 'i17rs',
    cdn: _cdn,
  });
  return _ls;
};

export const loadI17rDzAsync = async (pz: {
  i17r_fst: _ht.n,
  vsn?: _ht.n,
}) => {
  const _gUserz = gs.useUserz();
  let _cdn = (pz?.vsn && pz?.vsn > 0) ? (cmFTH.vdd(false) + ` AND _vsn = ${pz?.vsn}`) : cmFTH.vdd();
  _cdn += ` AND i17r_31r1f = ${_gUserz.crt._31rz._fst}`;
  if (pz.i17r_fst) _cdn += ` AND _fst = ${pz.i17r_fst}`;
  const _dz = await cmFTH.loadDzAsync({
    tgt: 'i17rs',
    cdn: _cdn,
  });
  return {
    i17rz: { ... _dz, cldz: undefined },
  };
};

export const loadI17rRzAsync = async (pz: {
  _31r_fst: _ht.n,
  i1zr_fst?: _ht.n,
  i1zrd3100s?: _ht.s,
  i1zrs1100iMnm?: _ht.n,
  i1z2a1100i?: _ht.n,
  i1z2a1200i?: _ht.n,
  i17r_fsts?: _ht.ls,
}) => {

  let _cdn1 = cmFTH.vdd() + ` AND i17r_31r1f = ${pz._31r_fst}`;
  if (_hm.f(pz.i17r_fsts)) _cdn1 += ` AND _fst IN (${_hm.join(pz.i17r_fsts)})`;

  let _cdn2 = cmFTH.vdd() + ` AND i1z2i17r1f = {i17r_fst}`;
  if (pz.i1zrd3100s) _cdn2 += ` AND i1z2i1zr1k IN (SELECT _key FROM i1zrs WHERE COALESCE(_dlt,-1)<>1 AND _vsn=_ltt AND i1zr_31r1f={i17r_31r1f} AND i1zrs1100i >= ${pz.i1zrs1100iMnm ?? -1} AND i1zrd3100s='${pz.i1zrd3100s}')`;
  if (pz.i1zr_fst) _cdn2 += ` AND i1z2i1zr1k NOT IN (SELECT _key FROM i1zrs WHERE COALESCE(_dlt,-1)<>1 AND _vsn=_ltt AND i1zr_31r1f={i17r_31r1f} AND _fst = ${pz.i1zr_fst})`;
  if (pz.i1z2a1100i) _cdn2 += ` AND i1z2a1200i > ${pz.i1z2a1100i}`;
  if (pz.i1z2a1200i) _cdn2 += ` AND i1z2a1100i < ${pz.i1z2a1200i}`;
  //hf.l(`IcvI17_Mz 103: ${hf.s(_cdn2)}`);

  const _i17rs = await cmFTH.loadLsAsync({
    tgt: 'i17rs',
    cdn: _cdn1,
    lwrz: {
      i1z2s: {
        tgt: 'i1z2s',
        cdn: _cdn2,
        rlcz: {
          i17r_fst: 'i17rs._fst',
          i17r_31r1f: 'i17rs.i17r_31r1f',
        }
      }

    }
  });

  //hf.l(`IcvI17_Mz 121: ${hf.s(_i17rs)}`);
  const _rz = {} as _ht.dz;
  _i17rs.map((_i17rz: _ht.dz) => {
    const _hold = _i17rz.i17ra1100i;
    const _use = _i17rz.cldz.i1z2s.length ?? 0;
    const _rmn = _hold - _use;
    _rz[_i17rz._fst] = {
      hold: _hold, // 保有数
      use: _use, // 使用数
      rmn: _rmn // 残数
    }
  });

  //hf.l(`IcvI17_Mz 134: ${hf.s(_rz)}`);
  return _rz;
};

export const saveI17rDzAsync = async (pz: {
  i17z: _ht.dz,
}) => {
  const _dz = await cmFTH.ugdDzAsync({
    tgt: 'i17rs',
    dz: {
      ... pz.i17z.i17rz,
    },
  });
  return {
    i17rz: { ... _dz, cldz: undefined },
  };
};
